import {Injectable} from '@angular/core';
import {BehaviorSubject, Subject} from 'rxjs';
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
  export class SideService {
  activeComponent$ = new BehaviorSubject(null);

  closed$ = new Subject();

  constructor(private http: HttpClient) {
  }

  open(component): void {
    this.activeComponent$.next(this.activeComponent$.getValue() ? null : component);
  }

  close(): void {
    this.activeComponent$.next(null);
  }
}
